import { render, staticRenderFns } from "./gestMateriale.vue?vue&type=template&id=687c4c18&scoped=true&"
import script from "./gestMateriale.vue?vue&type=script&lang=js&"
export * from "./gestMateriale.vue?vue&type=script&lang=js&"
import style0 from "./gestMateriale.vue?vue&type=style&index=0&id=687c4c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c4c18",
  null
  
)

export default component.exports